import type { GlobalModifier } from '@mattoespresso/brew-firestore';

import { collection } from 'firebase/firestore';
import { useContext, createContext } from 'react';
import { COLLECTIONS } from '@mattoespresso/brew-firestore';

import { useCollectionData } from 'src/hooks/useCollectionData';

import { FIRESTORE } from 'src/lib/firebase';

const GlobalModifiersContext = createContext<{
  data: GlobalModifier[];
  loading: boolean;
  error: any;
}>({
  data: [],
  loading: false,
  error: null,
});

export function useGlobalModifiers() {
  return useContext(GlobalModifiersContext);
}

export function GlobalModifiersProvider({ children }: { children: React.ReactNode }) {
  const value = useCollectionData<GlobalModifier>({
    collectionName: COLLECTIONS.modifiers,
    query: collection(FIRESTORE, COLLECTIONS.modifiers),
  });

  return (
    <GlobalModifiersContext.Provider value={value}>{children}</GlobalModifiersContext.Provider>
  );
}
